export const PENDING = 'pending';
export const REJECTED = 'rejected';
export const APPROVED = 'approved';

export default Object.freeze({
  PENDING,
  REJECTED,
  APPROVED,
});
